import * as React from 'react';
import styled from 'styled-components';
import radialShadow from '../images/radialShadow.jpg';

const Section = styled.section`
	color: black;
	background-image: ${(props) => `url('${radialShadow}')`};
	min-height: 545px;
	background-size: auto;
	background-position: center center;
	background-repeat: no-repeat;
	width: 100%;
	max-width: none;
	padding-top: 0;
	margin-bottom: 2em;
	position: relative;

	@media (${(props) => props.theme.mediumUp}) {
		padding-bottom: 0;
	}

	& .centeredWrapper {
		padding: 0;
	}

	& .padding {
		padding: 0 ${(props) => props.theme.paddingMobile};

		@media (${(props) => props.theme.mediumUp}) {
			padding: 0 ${(props) => props.theme.paddingMediumUp};
		}
	}

	& .boxes {
		align-items: center;

		@media (${(props) => props.theme.largeUp}) {
			padding: 0 5.5%;
		}
	}

	& h2.blue {
		font-size: 20px;
		margin-top: 0.5em;
	}

	& .rounded-box {
		z-index: 9;
		max-width: 278px;
		padding: 3em 2.2em;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;

		@media (${(props) => props.theme.smallUp}) {
			min-height: 350px;
		}

		& h3 {
			margin-bottom: 0;
			padding: 10px 0.5em 5px;
			margin-bottom 10px;
			white-space: pre;

			@media (${(props) => props.theme.mediumUp}) {
				padding: 20px 0.5em 0;
				margin-bottom 20px;
			}
		}

		& p {
			max-width: 200px;
		}
	}

	& .solid {
		@media (${(props) => props.theme.largeUp}) {
			height: 163px;
			position: absolute;
			left: 0;
			top: calc(50% - 111px);
			width: 100%;
		}
	}
`;

const FeaturesAndBenefits = (props: any) => (
	<Section className='featuresAndBenefits full-width' style={props.extraStyle}>
		<div className='centeredWrapper'>
			<div className='padding'>
				<h2 className='blue'>Features &amp; Benefits</h2>
				<div className='boxes row row-flush'>
					<article className='rounded-box left col-12 col-md-4'>
						{props.leftIcon}
						<h3>{props.leftHeading}</h3>
						<p>{props.leftText}</p>
					</article>
					<article className='rounded-box middle col-12 col-md-4'>
						{props.middleIcon}
						<h3>{props.middleHeading}</h3>
						<p>{props.middleText}</p>
					</article>
					<article className='rounded-box right col-12 col-md-4'>
						{props.rightIcon}
						<h3>{props.rightHeading}</h3>
						<p>{props.rightText}</p>
					</article>
				</div>
			</div>
			<div className='solid' style={{backgroundColor: props.solidBgColor}} />
		</div>
	</Section>
);

export default FeaturesAndBenefits;
